import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

const TitleTypography = styled(Typography)`
  && {
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 0;

    &:not(.disable-min-height) {
      min-height: 36px;
    }

    &.sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
  }
`;

TitleTypography.defaultProps = {
  component: 'h1',
  variant: 'h5',
};

const Title = ({ title, titleHidden, disableMinHeight, className, ...props }) => (
  <TitleTypography
    {...props}
    className={`${clsx({
      'sr-only': titleHidden,
      'disable-min-height': disableMinHeight,
    })} ${className}`}
  >
    {title}
  </TitleTypography>
);

Title.propTypes = {
  title: PropTypes.string.isRequired,
  titleHidden: PropTypes.bool,
  disableMinHeight: PropTypes.bool,
  className: PropTypes.string,
};

Title.defaultProps = {
  titleHidden: false,
  disableMinHeight: false,
  className: undefined,
};

export default Title;
